import React, { Fragment } from "react";

const TextArea = ({ name, label, isRequired, error, ...rest }) => {
    return (
        <div className="form-group">
            <label htmlFor={name} className="control-label sr-only">
                {label}
            </label>
            {isRequired === "true" &&
                <Fragment>
                    <small id={name + "req"} style={{ color: "red" }}>اجباری</small>
                    <textarea
                        {...rest}
                        id={name}
                        name={name}
                    >
                    </textarea>
                </Fragment>
            }
            {isRequired === "false" &&
                <textarea
                    {...rest}
                    id={name}
                    name={name}
                >
                </textarea>
            }
            {error && <div className="alert alert-danger round">{error}</div>}
        </div>
    );
};

export default TextArea;
